import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { PDFJSStatic } from 'pdfjs-dist';
import * as PDFJS from 'pdfjs-dist/build/pdf';



@Component({
  selector: 'app-visor-pdf',
  templateUrl: './visor-pdf.component.html',
  styleUrls: ['./visor-pdf.component.scss']
})
export class VisorPdfComponent implements OnInit {
  @Input() src = '';
  @Output() estadopdf = new EventEmitter<string>();
  @ViewChild('viewpdf') viewpdf;
  
  page: number = 1;
  totalPages: number;
  isLoaded: boolean = false;

  // src = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";

  constructor() {
    
   }

  ngOnInit(): void {


    // const PDFJS: PDFJSStatic = require('pdfjs-dist');

    // PDFJS.getDocument('helloworld.pdf').then(console.log);
    // this.estadopdf.emit('completo');

  }

  docLeido() {
    if (this.src && this.src !== '') {
      this.estadopdf.emit('completo');
    } else {
      this.estadopdf.emit('incompleto');
    }
  }



  pagechanging(event) {
    console.log('ultima pagina', event);
  }
  pageRendered(event) {
    console.log('ultima pagina', event);
  }


  pageChange(event) {
    console.log('ultima pagina', event);
  }




  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData.numPages;
    this.isLoaded = true;
  }

  nextPage() {
    this.page++;
  }

  prevPage() {
    this.page--;
  }




}
